<template>
  <div class="search">
    <div class="content-1200">
      <div class="margin-b40">共为您找到<span class="fontWeight-500 color-main2">{{ pagination.total }}</span>条数据
      </div>
      <div class="result">
        <ul>
          <li v-for="(item,index) in searchList.slice((pagination.page - 1) * pagination.perPage, pagination.page * pagination.perPage)"
              :key="index" class="margin-b40 cursor" @click="handleDetail(item)">
            <div class="fontSize18 color-level1 ellipsis">{{ item.title }}</div>
            <div class="source fontSize12 color-level3">来源：{{ item.source == '1' ? 'pdf' : '资讯' }}</div>
            <div class="fontSize12 color-level2">{{ item.desc }}</div>
          </li>
        </ul>
        <Pagination
            v-if="pagination.total > pagination.perPage"
            class="text-center"
            @current-change="currentChange"
            :page-size="pagination.perPage"
            :total="pagination.total"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination.vue";
import {singleHomeSever} from "@/common/api-config";

export default {
  components: {Pagination},
  data() {
    return {
      pagination: {
        total: 0,
        page: 1,
        perPage: 10,
      },
      keyword: '',
      searchList: []
    }
  },
  watch: {
    "$route.query.keyword": {
      handler(newValue) {
        this.keyword = newValue;
        this.pagination.page = 1;
        this.queryList()
      },
      immediate: true
    }
  },
  methods: {
    queryList() {
      if (!this.keyword) return;
      singleHomeSever.querySearchList({
        keyword: this.keyword,
      }).then(res => {
        if (res.code == 0) {
          this.searchList = res.data
          this.pagination.total = res.data.length;
        } else {
          this.searchList = []
          this.pagination.total = 0
        }
      })
    },
    //翻页
    currentChange(val) {
      this.pagination.page = val;
    },
    handleDetail(item){
      if (item.type === 1) {
        this.$router.push({path: `/doc/${item.id}`})
      } else {
        this.$router.push({path: '/home/news/info', query: {newsId: item.id}})
      }
    }
  }
}
</script>


<style scoped lang="scss">
.search {
  min-height: calc(100vh - 298px - 120px - 64px);
  padding: 60px 0 80px;

  ul > li {
    font-weight: 500;

    &:last-of-type {
      margin-bottom: 60px !important;
    }

    .source {
      margin: 8px 0;
    }
  }

}
</style>
